import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";


const Leads = () => {
    const [leads, setLeads] = useState([]);
    const [search, setSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const imageUrl = "https://devapi.bykit.in/storage/users/";

    // Function to open Offcanvas and set row data
    const handleShowDetails = (lead) => {
        setSelectedLead(lead);
        setShowOffcanvas(true);
    };

    useEffect(() => {
        getLeadsData();
    }, [rowsPerPage, page]);


    const offcanvasRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showOffcanvas &&
                offcanvasRef.current &&
                !offcanvasRef.current.contains(event.target)
            ) {
                setShowOffcanvas(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showOffcanvas]);


    const labels = [
        "Meter",
        "Front Angle",
        "Right angle",
        "Left angle",
        "Back side",
        "Any dent/scratches"
    ];

    let formattedPickupTime = ''
    if (selectedLead && selectedLead.pickup_time) {
        const pickup = new Date(selectedLead.pickup_time);
        formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
    }

    let formattedreachedTime = ''
    if (selectedLead && selectedLead.reached_workshop_time) {
        const reached = new Date(selectedLead.reached_workshop_time);
        formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
    }

    let formattestartTime = ''
    if (selectedLead && selectedLead.start_service_time) {
        const start = new Date(selectedLead.start_service_time);
        formattestartTime = `${String(start.getDate()).padStart(2, '0')}-${String(start.getMonth() + 1).padStart(2, '0')}-${start.getFullYear()} ${String(start.getHours()).padStart(2, '0')}:${String(start.getMinutes()).padStart(2, '0')}`;
    }

    let formattecompleteTime = ''
    if (selectedLead && selectedLead.service_complete_time) {
        const complete = new Date(selectedLead.service_complete_time);
        formattecompleteTime = `${String(complete.getDate()).padStart(2, '0')}-${String(complete.getMonth() + 1).padStart(2, '0')}-${complete.getFullYear()} ${String(complete.getHours()).padStart(2, '0')}:${String(complete.getMinutes()).padStart(2, '0')}`;
    }

    let formatteDropTime = ''
    if (selectedLead && selectedLead.drop_time) {
        const drop = new Date(selectedLead.drop_time);
        formatteDropTime = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()} ${String(drop.getHours()).padStart(2, '0')}:${String(drop.getMinutes()).padStart(2, '0')}`;
    }


    let insuranceexpiry = ''
    if (selectedLead && selectedLead.insurance_expiry_date) {
        const drop = new Date(selectedLead.insurance_expiry_date);
        insuranceexpiry = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()}`;
    }


    const getLeadsData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/get-pickup-drop-history?start=${(page - 1) * rowsPerPage}&length=${rowsPerPage}&?type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('Delivery History', response.data)

            if (response.data && response.data.data) {
                setLeads(response.data.data);
                setTotalRows(response.data.recordsTotal || 0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleMarkAsConverted = async (leadId) => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        console.log('token', token);
        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/leads/mark-as-converted/${leadId}??type=live`,

                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Lead marked as converted:", response.data);
            if (response.data.status === "RC200") {
                toast.success("Lead Converted and Moved to Queue List", { position: "top-right" });

            } else {
                toast.error("Error Lead Converted ", { position: "top-right" });
            }

            setLeads((prevLeads) => prevLeads.filter((lead) => lead.id !== leadId));

            setShowModal(false);
        } catch (error) {
            console.error("Error marking lead as converted:", error);
            alert("Failed to mark lead as converted!");
        }
    };

    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newRows) => {
        setRowsPerPage(newRows);
        setPage(1);
    };


    const columns = [
        {
            name: "Created Date",
            cell: (row) => (
                <div className="">
                    <p>{row.date || ""}</p>
                    {
                        row.status === 7
                            ? '<button className="btn droppickup_btn mt-1">Service Started</button>'
                            : row.status === 6
                                ? '<button className="btn droppickup_btn mt-1">Approved</button>'
                                : row.status === 2
                                    ? '<button className="btn droppickup_btn mt-1">Assigned (Delivery)</button>'
                                    : ''
                    }
                </div>
            ),
            sortable: true, width: "200px"
        },
        {
            name: "Customer Name", selector: (row) => (
                <>
                    {row.customer_name || "N/A"}
                    <br />
                    {row.phone || ""}
                </>
            ), sortable: true,
        },
        { name: "Vehicle Number", selector: (row) => row.vehicle_name || "N/A", sortable: true, },

        {
            name: "Pickup/Drop",
            cell: (row) => {
                let buttonText = "N/A"; // Default text

                if (row.pickup_drop_facility === 0) {
                    buttonText = "Pickup";
                } else if (row.pickup_drop_facility === 3) {
                    buttonText = "Self Pickup/Drop";
                } else if (row.pickup_drop_facility === 1) {
                    buttonText = "Drop";
                } else if (row.pickup_drop_facility === 2) {
                    buttonText = "Pickup & Drop";
                }

                return (
                    <button className="btn droppickup_btn btn-sm">
                        {buttonText}
                    </button>
                );
            },
            sortable: true,
        },
        {
            name: "Address",
            cell: (row) => (
                <div className="">
                    <p>{row.address || "-"}</p>
                    {row.delivery_boy_name && <p><span style={{ fontWeight: 'bold' }}>Delivery Boy:</span> {row.delivery_boy_name}</p>}
                </div>
            ),
            sortable: true,
            width: "260px",
        },
        {
            name: "Action",
            width: "260px",
            cell: (row) => (
                <div className="d-flex justify-content-end">
                    <button className="edit_btn me-2"
                        data-tooltip-id={`view-tooltip-${row.id}`}
                        data-tooltip-content="View Details"
                        onClick={() => handleShowDetails(row)}>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
                            </g>
                        </svg>
                    </button>
                    <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                </div>
            ),
        },
    ];

    return (
        <div className="container data-table-container p-2">
            <ToastContainer></ToastContainer>
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Deliveries History</p>
            </div>
            <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
                <div>
                    <h4 className='dashboard_head ps-3 pb-4'>Deliveries History</h4>
                </div>
                <hr></hr>
                <div className="d-flex justify-content-between mt-3 px-3">

                    <div>
                        <input
                            type="text"
                            placeholder="Search keyword"
                            className="search-input"
                            style={{ padding: '8px' }}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                <DataTable
                    columns={columns}
                    data={leads.filter((item) => item.customer_name && item.customer_name.toLowerCase().includes(search.toLowerCase()))}
                    // data={leads}

                    pagination
                    responsive
                    // paginationServer
                    //paginationTotalRows={totalRows}
                    paginationPerPage={rowsPerPage}
                    paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    customStyles={{
                        headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                        pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                        cells: {
                            style: {
                                padding: "5px", // Reduces space between columns
                                margin: "0",
                            },
                        },
                        headCells: {
                            style: {
                                padding: "10px", // Reduces space in header cells
                                margin: "0",
                            },
                        },
                    }}
                />

            </div>

            <div>
                <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title></Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        {selectedLead && (

                            <div className="lead-details" ref={offcanvasRef}>

                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                        <h4 className="detail_title">Service Details</h4>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                        <h4 className="detail_title">Customer Details</h4>
                                    </div>
                                </div>
                                <hr style={{ marginBottom: 10, marginTop: 10 }} />

                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Date</h4>
                                                <p className="detail_text">{selectedLead.date}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Service Type</h4>
                                                <p className="detail_text">
                                                    {selectedLead.service_type === 0
                                                        ? `Free / ${selectedLead.free_service_no} Free Service`
                                                        : 'Paid'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Name</h4>
                                                <p className="detail_text">{selectedLead.customer_name}-{selectedLead.phone}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Vehicle Number:</h4>
                                                <p className="detail_text">{selectedLead.vehicle_name}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">

                                            <div className="col-4">
                                                <h4 className="detail_title">Total Amount</h4>
                                                <p className="detail_text">{selectedLead.total_amount || "-"}</p>
                                            </div>
                                            <div className="col-4">
                                                <h4 className="detail_title">Payment Status</h4>
                                                <p className="detail_text">{selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}</p>
                                            </div>

                                            <div className="col-4">
                                                {selectedLead.invoice ?
                                                    <div>
                                                        <h4 className="detail_title">Invoice</h4>
                                                        <p className="detail_text"> <Link
                                                            to={'https://devapi.bykit.in/storage/brands/' + `${selectedLead.invoice}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ marginRight: 10 }}
                                                        >
                                                            View Invoice
                                                        </Link></p></div> : null
                                                }
                                            </div>

                                        </div>
                                    </div>

                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 className="detail_title">Address</h4>
                                                <p className="detail_text">{selectedLead.address}</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Pickup/Drop</h4>
                                                <div className="mt-2">
                                                    <span className="btn droppickup_btn btn-sm">
                                                        {selectedLead?.pickup_drop_facility === 0
                                                            ? "Pickup"
                                                            : selectedLead?.pickup_drop_facility === 3
                                                                ? "Self Pickup/Drop"
                                                                : selectedLead?.pickup_drop_facility === 1
                                                                    ? "Drop"
                                                                    : "Pickup & Drop"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Pickup/drop Charges </h4>
                                                <p className="detail_text">{selectedLead.pickupdrop_price ? selectedLead.pickupdrop_price : 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">

                                            </div>
                                            <div className="col-6">

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Pickup Time</h4>
                                                <p className="detail_text">{formattedPickupTime}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Pickup Images</h4>
                                                <div className="d-flex flex-wrap">
                                                    {selectedLead.pickup_photos && selectedLead.pickup_photos.split(",").map((photo, index) => (
                                                        <div style={{ fontSize: 12, width: '45%' }}>
                                                            {labels[index] || `Photo ${index + 1}`}
                                                            <Link
                                                                key={index}
                                                                to={`${imageUrl}${photo}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ marginRight: 10 }}
                                                            >
                                                                <img
                                                                    src={`${imageUrl}${photo}`}
                                                                    alt=""
                                                                    className="pick_photo"
                                                                    onError={(e) => (e.target.style.display = "none")}
                                                                />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <h4 className="detail_title">Vehicle Details</h4>
                                            <hr style={{ marginBottom: 10, marginTop: 10 }} />
                                            <div className="col-4">
                                                <h4 className="detail_title">Vehicle Number</h4>
                                                <p className="detail_text">{selectedLead.vehicle_name}</p>
                                            </div>
                                            <div className="col-4">
                                                <h4 className="detail_title">Brand</h4>
                                                <p className="detail_text">  {selectedLead?.brand_logo && (
                                                    <img
                                                        src={selectedLead.brand_logo}
                                                        alt="Brand Logo"
                                                        style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                                                        onError={(e) => (e.target.style.display = "none")}
                                                    />
                                                )}
                                                </p>
                                            </div>

                                            <div className="col-4">
                                                <h4 className="detail_title">Model</h4>
                                                <p className="detail_text">{selectedLead.model_name}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Workshop Reaching Time</h4>
                                                <p className="detail_text">{formattedreachedTime}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Drop to workshop</h4>
                                                <div className="d-flex flex-wrap">
                                                    {selectedLead.receive_photo && selectedLead.receive_photo.split(",").map((photo, index) => (
                                                        <div style={{ fontSize: 12, width: '45%' }}>
                                                            {labels[index] || `Photo ${index + 1}`}
                                                            <Link
                                                                key={index}
                                                                to={`${imageUrl}${photo}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ marginRight: 10 }}
                                                            >
                                                                <img
                                                                    src={`${imageUrl}${photo}`}
                                                                    alt=""
                                                                    className="pick_photo"
                                                                    onError={(e) => (e.target.style.display = "none")}
                                                                />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Insurance Number</h4>
                                                <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Insurance Company</h4>
                                                <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Service Started Time</h4>
                                                <p className="detail_text">{formattestartTime}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Service Complete Time</h4>
                                                <p className="detail_text">{formattecompleteTime}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Insurance</h4>
                                                <Link to={imageUrl + selectedLead.insurance_copy_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Insurance Expiry Date</h4>
                                                <p className="detail_text">{insuranceexpiry != '01-01-1970' ? insuranceexpiry : "-"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>








                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <h4 className="detail_title">Pickup from workshop</h4>
                                                <p className="detail_text"> {selectedLead.work_complete_photo && selectedLead.work_complete_photo.split(",").map((photo, index) => (
                                                    <div style={{ fontSize: 12, width: '45%' }}>
                                                        {labels[index] || `Photo ${index + 1}`}
                                                        <Link
                                                            key={index}
                                                            to={`${imageUrl}${photo}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ marginRight: 10 }}
                                                        >
                                                            <img
                                                                src={`${imageUrl}${photo}`}
                                                                alt=""
                                                                className="pick_photo"
                                                                onError={(e) => (e.target.style.display = "none")}
                                                            />
                                                        </Link>
                                                    </div>
                                                ))}</p>
                                            </div>
                                            <div className="col-6">
                                                <h4 className="detail_title">Drop to customer</h4>
                                                <p className="detail_text">{selectedLead.delivery_complete_photo && selectedLead.delivery_complete_photo.split(",").map((photo, index) => (
                                                    <div style={{ fontSize: 12, width: '45%' }}>
                                                        {labels[index] || `Photo ${index + 1}`}
                                                        <Link
                                                            key={index}
                                                            to={`${imageUrl}${photo}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ marginRight: 10 }}
                                                        >
                                                            <img
                                                                src={`${imageUrl}${photo}`}
                                                                alt=""
                                                                className="pick_photo"
                                                                onError={(e) => (e.target.style.display = "none")}
                                                            />
                                                        </Link>
                                                    </div>
                                                ))}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 className="detail_title">RC Book:</h4>
                                                <Link to={imageUrl + selectedLead.rc_book_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>




                                <div className="row">
                                    {/* First column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 className="detail_title">Drop Time</h4>
                                                <p className="detail_text">{formatteDropTime}</p>
                                            </div>
                                            <div className="col-12">
                                                <h4 className="detail_title">Message From Customer</h4>
                                                <p className="detail_text">{selectedLead.message}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Second column */}
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <h4 className="detail_title" style={{ marginTop: 30 }}>Ratings</h4>
                                            <hr style={{ marginBottom: 10, marginTop: 10 }} />
                                            <div className="col-6">
                                                <h4 className="detail_title">Ratings for Delivery Boy</h4> {selectedLead.rate_delivaryboy && Array.from({ length: 5 }, (_, i) => (
                                                    <span key={i} className={i < selectedLead.rate_delivaryboy ? "star filled" : "star"}>
                                                        {i < selectedLead.rate_delivaryboy ? '★' : '☆'}
                                                    </span>
                                                ))}
                                                {selectedLead.rate_delivaryboy ? <p className="detail_text">{selectedLead.comment_delivaryboy}</p> :
                                                    <p className="detail_text">No Rating given by User till now.</p>
                                                }
                                            </div>
                                            <div className="col-6">

                                                <h4 className="detail_title">Ratings for Service</h4> {selectedLead.rate_workshop && Array.from({ length: 5 }, (_, i) => (
                                                    <span key={i} className={i < selectedLead.rate_workshop ? "star filled" : "star"}>
                                                        {i < selectedLead.rate_workshop ? '★' : '☆'}
                                                    </span>
                                                ))}
                                                {selectedLead.rate_workshop ? <p className="detail_text">{selectedLead.comment_workshop}</p> :
                                                    <p className="detail_text">No Rating given by User till now.</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Offcanvas.Body>
                </Offcanvas>
            </div>

            {/* Modal */}
            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className='delete_text'>Are you sure, do you want to mark as converted?</p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={() => {
                                handleMarkAsConverted(selectedLead.id)
                            }} className='model_dlt_btn'>Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Leads;
